module.exports = __webpack_public_path__ + "static/hunter-douglas-sheers-973442da6e8090cf1bfa0295344ccfa8.png";